import { createSelector } from '@ngrx/store';
import { UserState } from './user.reducer';
import { AppState } from './app.state';

export const selectUserState = (state: AppState): UserState => state.userState;

export const selectCurrentUser = createSelector(
  selectUserState,
  (state: UserState) => state.user
);

export const selectUserLoading = createSelector(
  selectUserState,
  (state: UserState) => state.loading
);
